/**
 * 電話番号ユーティリティ関数
 *
 * APIは電話番号として数字のみを期待するため、
 * すべての非数字文字（括弧、ハイフン、スペース、ピリオドなど）を削除する必要がある。
 *
 * 各国の電話番号フォーマット例：
 * - アメリカ: (202) 588-6500 → 2025886500
 * - 日本: 090-1234-5678 → 09012345678
 * - イギリス: 020 7946 0123 → 02079460123
 */

/**
 * 電話番号から数字以外の文字をすべて削除する
 *
 * @param phoneNumber - フォーマットされた電話番号（括弧、ハイフン、スペースなどを含む可能性がある）
 * @returns 数字のみの電話番号
 *
 * @example
 * normalizePhoneNumber("(202) 588-6500") // "2025886500"
 * normalizePhoneNumber("090-1234-5678")  // "09012345678"
 * normalizePhoneNumber("020 7946 0123")  // "02079460123"
 */
export const normalizePhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace(/\D/g, '');
};
